<template>
	<view class="activity-container">
		<view class="base-message">
			<view class="message-item">
				<view class="label must">菜品名称</view>
				<view class="message-value">
					<input
						v-model="form.realName"
						placeholderStyle="color:#ccc; font-size: 30rpx;"
						placeholder="请输入菜品名称"
					/>
				</view>
			</view>
			<view class="message-item">
				<view class="logo">
					<view class="label must">活动图片</view>
					<text class="label-tip">上传png/jpg格式图片1张，建议尺寸：264*176px</text>
				</view>
				<view class="message-value">
					<uni-file-picker limit="1">
					</uni-file-picker>
				</view>
			</view>
			
			
			<view class="message-item">
				<view class="label must">菜品价格（元）</view>
				<view class="message-value">
					<input
						:inputBorder="false"
						type="number"
						v-model="form.numLimt"
						placeholderStyle="color:#ccc; font-size: 30rpx;"
						placeholder="0" />
				</view>
			</view>
			
			
			<view class="message-item">
				<view class="label">排序码（倒序）</view>
				<view class="message-value">
					<input
						:inputBorder="false"
						type="number"
						v-model="form.numLimt"
						placeholderStyle="color:#ccc; font-size: 30rpx;"
						placeholder="0" />
				</view>
			</view>
			<view class="message-item">
				<view class="label">菜品介绍</view>
				<view class="message-value">
					<uni-easyinput
						:inputBorder="false"
						v-model="form.content"
						autoHeight
						placeholder="请输入菜品的特色介绍"
						placeholderStyle="color:#ccc; font-size: 30rpx;"
						type="textarea"
					/>
				</view>
			</view>
			<view class="next-btn" @click="save">保存菜品</view>
			<view class="safe-area"></view>
		</view>
		<view class="pickers" style="">
			<uni-datetime-picker ref="activityTime"  @change="change" type="datetimerange" rangeSeparator="至" />
			<uni-datetime-picker ref="activityApplyTime"  @change="applyChange" type="datetimerange" rangeSeparator="至" />
		</view>
	</view>
</template>

<script>
	export default {
		data() {
			return {
				form: {
					activityType: '',
					datetimerange: '',
					startDate: '',
					endDate: '',
					startApplyDate: '',
					endApplyDate: '',
					address: '',
					numLimt: '',
				},
				activityTypes: ['2131', 'dsada']
			};
		},
		onLoad(props) {
			console.log(props);
			if (props.title) {
				uni.setNavigationBarTitle({
				    title: props.title
				});
			}
		},
		methods: {
			updataType(v) {
				this.form.activityType = v
			},
			picker() {
				this.$refs.activityTime.show()
			},
			pickerApply() {
				this.$refs.activityApplyTime.show()
			},
			change(v) {
				console.log(v);
				thi.form.startDate = v[0]
				thi.form.endDate = v[1]
			},
			applyChange(v) {
				console.log(v);
				thi.form.startApplyDate = v[0]
				thi.form.endApplyDate = v[1]
			},
			selectAddress() {
				uni.navigateTo({
					url: '/pages/selectLocation/selectLocation'
				})
			},
			save() {
				
			}
		}
		
	}
</script>

<style lang="scss" scoped>
.activity-container {
	height: 100%;
	background-color: #fff;
	overflow-y: scroll;
	overflow-x: hidden;
}
.base-message {
	background-color: #FFFFFF;
	padding: 20rpx 32rpx;
	box-sizing: border-box;
	width: 100%;
	.message-item {
		// height: 148rpx;
		padding: 30rpx 0;
		box-sizing: border-box;
		border-bottom: 2rpx solid #F4F5F4;
		.logo {
			display: flex;
			.label-tip {
				height: 36rpx;
				font-size: 24rpx;
				font-weight: 400;
				color: #999999;
				line-height: 36rpx;
			}
		}
		.label {
			line-height: 30rpx;
			height: 30rpx;
			font-size: 30rpx;
			font-weight: 500;
			margin-bottom: 24rpx;
			
		}
		.must {
			&::after {
				content: ' *';
				color: #D20A0A;
			}
		}
		.message-value {
			line-height: 30rpx;
			font-size: 30rpx;
			display: flex;
			justify-content: space-between;
			.rule {
				display: flex;
				text-align: right;
				line-height: 35px;
				.name {
					margin-right: 20rpx;
				}
				.rule-value {
					flex: 1;
					display: flex;
					border-radius: 8rpx;
					border: 2rpx solid #E5E5E5;
					box-sizing: border-box;
					padding: 0 16rpx;
					input {
						margin: auto 0;
					}
				}
			}
			input {
				flex: 1;
			}
			.un-select {
				font-size: 28rpx;
				color: #CCCCCC;
			}
			.labels {
				flex: 1;
				display: flex;
				flex-wrap: wrap;
				.label-item {
					padding: 10rpx 12rpx;
					background: rgba(210,10,10,0.1);
					border-radius: 4rpx;
					font-size: 24rpx;
					font-family: PingFangSC-Regular, PingFang SC;
					font-weight: 400;
					color: #D20A0A;
					line-height: 24rpx;
					margin-right: 12rpx;
					margin-bottom: 12rpx;
				}
			}
		}
	}
}
.parting {
	background: #f7f7f7;
	height: 16rpx;
	width: 120%;
	margin-left:-33rpx;
}
.bran-story {
	padding-top: 44rpx;
	border-bottom: 2rpx solid #F4F5F4;
	.label {
		line-height: 30rpx;
		height: 30rpx;
		font-size: 30rpx;
		font-weight: 500;
		margin-bottom: 24rpx;
	}
}
.next-btn {
	height: 72rpx;
	margin: 126rpx 56rpx 0;
	background: linear-gradient(270deg, #D20A0A 0%, #D95A5A 100%);
	border-radius: 36rpx 36rpx 36rpx 36rpx;
	color: #FFFFFF;
	line-height: 72rpx;
	text-align: center;
}
.save-btn {
	padding-bottom: env(safe-area-inset-bottom);
	
}
.safe-area {
	height: env(safe-area-inset-bottom);
	padding: 20rpx;
}
.pickers {
	position: fixed;
	bottom: -300rpx;
	z-index:9999;
}
/deep/ .uni-calendar-item--checked {
	background-color: #D20A0A!important;
}
/deep/ .uni-calendar-item--multiple .uni-calendar-item--before-checked, .uni-calendar-item--multiple .uni-calendar-item--after-checked {
	background-color: #D20A0A!important;
}
/deep/ .uni-datetime-picker--btn {
	background: linear-gradient(270deg, #D20A0A 0%, #D95A5A 100%);
}
</style>
